const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div id="speaking-listing">
  `);
                this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 2, 177), undefined, false, false, 2));
                this.echo(`  <div class="o-container o-container--pad">
    <div class="o-container__content">
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 21, 182), new Map([[`class`, `o-rhythm--generous`]]), true, false, 21));
                this.echo(`    </div>
  </div>
  `);
                this.echo(this.include(context, this.source, `@cloudfour/components/ground-nav/ground-nav.twig`, new Map([[`menu`, new Map([[`items`, new Map([[0, new Map([[`link`, `/does`], [`title`, `What We Do`], [`current`, true]])], [1, new Map([[`link`, `/believes`], [`title`, `Our Approach`]])], [2, new Map([[`link`, `/made`], [`title`, `Our Work`]])], [3, new Map([[`link`, `/thinks`], [`title`, `Articles`]])], [4, new Map([[`link`, `/presents`], [`title`, `Speaking`]])], [5, new Map([[`link`, `/contributes`], [`title`, `Labs`]])], [6, new Map([[`link`, `/is`], [`title`, `Team`]])], [7, new Map([[`link`, `/portland-device-lab`], [`title`, `Device Lab`]])], [8, new Map([[`link`, `https://cloudfour-patterns.netlify.app/`], [`title`, `Patterns`]])], [9, new Map([[`link`, `https://www.responsivefieldday.com/`], [`title`, `Responsive Field Day`]])]])]])], [`social`, new Map([[`items`, new Map([[0, new Map([[`link`, `https://twitter.com/cloudfour`], [`title`, `Follow us on Twitter`], [`icon`, `brands/twitter`]])], [1, new Map([[`link`, `https://github.com/cloudfour`], [`title`, `Find us on GitHub`], [`icon`, `brands/github`]])], [2, new Map([[`link`, `https://www.instagram.com/cloudfourpdx/`], [`title`, `Follow us on Instagram`], [`icon`, `brands/instagram`]])], [3, new Map([[`link`, `https://www.linkedin.com/company/cloud-four`], [`title`, `Follow us on LinkedIn`], [`icon`, `brands/linkedin`]])]])]])], [`action`, new Map([[`lead_in`, `Let’s discuss your project!`], [`title`, `Email us`], [`link`, `mailto:info@cloudfour.com`], [`icon`, `envelope`]])], [`organization`, new Map([[`name`, `Cloud Four, Inc.`], [`address`, new Map([[`street_address`, `510 SW 3rd Ave, Suite 420`], [`address_locality`, `Portland`], [`address_region`, `Oregon`], [`postal_code`, `97204`], [`address_country`, `USA`]])], [`email`, `info@cloudfour.com`], [`telephone`, `+1 (503) 290-1090`], [`url`, `https://cloudfour.com/`], [`founding_date`, `2007-12-13`]])]]), false, false, 92));
                this.echo(`</div>
`);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [177, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/cloud-cover/cloud-cover.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 2);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/cloud-cover/cloud-cover.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 4, 176), new Map([[`class`, `o-rhythm--condensed`]]), false, false, 4));
                this.echo(`    `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [176, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 4);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -2], [`content`, `Speaking`]]), false, false, 8));
                this.echo(`          <p>
            Saying what we mean, meaning what we say
          </p>
        `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [182, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 21);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`tag_name`, `h2`], [`content`, `Future Events`]]), false, false, 25));
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 30, 179), undefined, true, false, 30));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/heading/heading.twig`, new Map([[`level`,  -1], [`tag_name`, `h2`], [`content`, `Our Talks`]]), false, false, 51));
                this.echo(`          `);
                this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 56, 181), undefined, true, false, 56));
                this.echo(`        `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [179, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 30);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`future`) ? context.get(`future`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`                <a href="#" class="media-link">
                `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 34, 178), new Map([[`reverse_markup`, true]]), true, false, 34));
                    this.echo(`                </a>
              `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`            `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [178, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 34);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/calendar-date/calendar-date.twig`, new Map([[`datetime`, this.traceableMethod(this.getAttribute, 37, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `date`, new Map([]), `any`, false, false, false)], [`note`, this.traceableMethod(this.getAttribute, 38, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `note`, new Map([]), `any`, false, false, false)]]), false, false, 36));
                this.echo(`                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <h3>`);
                this.echo(this.env.getFilter('escape').traceableCallable(42, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 42, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `event`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</h3>
                    <p>`);
                this.echo(this.env.getFilter('escape').traceableCallable(43, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 43, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `location`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</p>
                    <p>Speaker: `);
                this.echo(this.env.getFilter('escape').traceableCallable(44, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 44, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `speaker`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</p>
                  `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [181, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 56);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`              `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`speaking`) ? context.get(`speaking`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                context.set('loop', new Map([
                  ['parent', context.get('_parent')],
                  ['index0', 0],
                  ['index', 1],
                  ['first', true]
                ]));
                if ((typeof context.get('_seq') === 'object') && this.isCountable(context.get('_seq'))) {
                    let length = this.count(context.get('_seq'));
                    let loop = context.get('loop');
                    loop.set('revindex0', length - 1);
                    loop.set('revindex', length);
                    loop.set('length', length);
                    loop.set('last', (length === 1));
                }
                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`item`] = __value__;
                    this.echo(`                `);
                    this.echo(this.include(context, this.source, this.loadTemplate(`d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 59, 180), new Map([[`class`, (context.has(`_card_class`) ? context.get(`_card_class`) : null)], [`href`, this.traceableMethod(this.getAttribute, 61, this.source)(this.env, context.get(`item`), `link`, new Map([]), `any`, false, false, false)]]), true, false, 59));
                    this.echo(`              `);
                    (() => {
                        let loop = context.get('loop');
                        loop.set('index0', loop.get('index0') + 1);
                        loop.set('index', loop.get('index') + 1);
                        loop.set('first', false);
                        if (loop.has('length')) {
                            loop.set('revindex0', loop.get('revindex0') - 1);
                            loop.set('revindex', loop.get('revindex') - 1);
                            loop.set('last', loop.get('revindex0') === 0);
                        }
                    })();
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('item');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`            `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
        [180, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/card/card.twig`, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, 59);

                this.blocks = new Map([
                    ['heading', [this, 'block_heading']],
                    ['cover', [this, 'block_cover']],
                    ['content', [this, 'block_content']],
                    ['footer', [this, 'block_footer']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/card/card.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_heading(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    `);
                this.echo(this.env.getFilter('escape').traceableCallable(64, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 64, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `title`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`
                  `);
            }

            block_cover(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <img src="`);
                this.echo(this.env.getFilter('escape').traceableCallable(67, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 67, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `thumbnail`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`" alt="">
                  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <p>
                      `);
                this.echo(this.env.getFilter('escape').traceableCallable(71, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `description`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(` `);
                if (this.traceableMethod(this.getAttribute, 71, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `more`, new Map([]), `any`, false, false, false)) {
                    this.echo(`<span class="more-text">`);
                    this.echo(this.env.getFilter('escape').traceableCallable(71, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 71, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `more`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</span>`);
                }
                this.echo(`                    </p>
                  `);
            }

            block_footer(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`                    <div class="c-author o-media">
                      <div class="o-media__object">
                        `);
                this.echo(this.include(context, this.source, `@cloudfour/components/avatar/avatar.twig`, new Map([[`src`, this.traceableMethod(this.getAttribute, 77, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `avatar`, new Map([]), `any`, false, false, false)]]), false, false, 77));
                this.echo(`                      </div>
                      <div class="o-media__content">
                        <p<a href="#">`);
                this.echo(this.env.getFilter('escape').traceableCallable(80, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 80, this.source)(this.env, (context.has(`item`) ? context.get(`item`) : null), `author`, new Map([]), `any`, false, false, false), `html`, null, true]));
                this.echo(`</a></p>
                      </div>
                    </div>
                  `);
            }

            getTemplateName() {
                return `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'd7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591');

let template = env.loadTemplate('d7348b62e26520460e0960a52c4a380e0f1f65df66535b5c6ee43e4cbb33a591');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/prototypes/speaking-listing/example/example.twig", args: context }
     );
     return rendered;;
};